// frontend/src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Atkinson Hyperlegible", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji","Segoe UI Emoji"',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          backgroundColor: '#000000',
          color: '#EAD7B2',
        },
        body: {
          textRendering: 'optimizeLegibility',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          backgroundColor: '#000000',
          color: '#EAD7B2',
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#3AAFA9', // Soft Teal, main for buttons, headers, and important UI elements
      contrastText: '#EAD7B2',
    },
    secondary: {
      main: '#A594F9', // Muted Lavender, secondary for highlights, borders, and secondary buttons
      contrastText: '#EAD7B2',
    },
    accent: {
      main: '#FF6B6B', // Warm Coral, accent, sparingly for CTAs, warnings, and interactive elements
    },
    background: {
      default: '#000000',
      paper: '#000000',
    },
    text: {
      primary: '#EAD7B2',
      secondary: '#EAD7B2',
    },
  },
});

export default theme;
